import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";

import App from './App';
import Authentication from "./components/authentication";



ReactDOM.render(
  <Router>
    <Authentication>
      <App />
    </Authentication>
  </Router>,
  document.getElementById('root')
);


